import { render, staticRenderFns } from "./GovAffairsLove.vue?vue&type=template&id=25ceb012&"
import script from "./GovAffairsLove.vue?vue&type=script&lang=js&"
export * from "./GovAffairsLove.vue?vue&type=script&lang=js&"
import style0 from "./GovAffairsLove.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports